import {productionOrder} from './state';

export function setProductionOrders(state, production_orders) {
    state.production_orders = production_orders;
}

export function setProductionOrder(state, production_order) {
    state.production_order_operations = [];
    let production_order_operations = [];

    if (!!production_order.production_order_operations) {
        production_order.production_order_operations.map(poo => {
            poo.document.documents_products.map(dp => {

                dp.documents_products_lots = dp.document_product_lots;

                let branch_office_warehouse_exit = dp.branchoffice_warehouse;

                let branch_office_warehouse_entrance = null;

                if (poo.document.id !== poo.document.thread) {
                    poo.document.document_thread.map(dt => {
                        dt.documents_products.map(dpt => {

                            dpt.documents_products_lots = dpt.document_product_lots;

                            if (dpt.product_id === dp.product_id) {
                                branch_office_warehouse_entrance = dpt.branchoffice_warehouse;
                            }
                        });
                    });
                }

                production_order_operations.push({
                    id: poo.document.id,
                    date: poo.document.document_date,
                    code_operation: poo.parameter_operation.code_parameter,
                    operation: poo.parameter_operation.name_parameter,
                    document: poo.document.consecutive,
                    branch_office_warehouse_exit_id: branch_office_warehouse_exit.id,
                    branch_office_warehouse_exit: branch_office_warehouse_exit.warehouse_description,
                    branch_office_warehouse_entrance_id: branch_office_warehouse_entrance ? branch_office_warehouse_entrance.id : null,
                    branch_office_warehouse_entrance: branch_office_warehouse_entrance ? branch_office_warehouse_entrance.warehouse_description : null,
                    product: dp.product.code + ' - ' + dp.product.description,
                    quantity: dp.quantity,
                    inventory_unit_cost_value: dp.inventory_cost_value / dp.quantity,
                    inventory_cost_value: dp.inventory_cost_value,
                    documents_products_lots: dp.documents_products_lots,
                    observation: dp.observation
                });
            });
        });
    }

    state.production_order_operations = production_order_operations;

    production_order.documents_products = [];
    state.production_order = production_order;
}

export function setContacts(state, contacts) {
    state.contacts = contacts;
}

export function setProducts(state, products) {

    products.map(p => {
        p.stock = 0;

        if (p.inventory) {
            p.inventory.map(i => {
                p.stock += i.stock;
            });
        }
    });

    state.products = products;
}

export function addDocumentProduct(state, document_product) {
    state.production_order.documents_products.push(document_product);
}

export function setOperations(state, operations) {
    state.operations = operations.sort((a, b) => a.alphanum_data_first - b.alphanum_data_first);
}

export function setLots(state, lots) {
    state.lots.data = [];
    lots.map(item => {
        item.quantity = 0;
        state.lots.data.push(item);
    });
}

export function setDocumentProduct(state, document_product) {
    state.document_product = document_product;
}

export function setModalLotsShow(state, show) {
    state.modal_lots.show = show;
}

export function setDocumentsProductsProductionOrder(state, documents_products) {
    state.production_order.documents_products = documents_products;
}

export function resetProductionOrder(state) {
    state.production_order = productionOrder();
    state.production_order_operations = [];
}

export function setEditing(state, editing) {
    state.editing = editing;
}

export function setBranchOfficeMain(state, branch_office_main) {
    state.branch_office_main = branch_office_main;
}

export function setOperationIdProductionOrder(state, operation_id) {
    state.production_order.operation_id = operation_id;
}

export function setBranchOfficeWarehouseAvailable(state, branch_office_warehouse_available) {
    state.branch_office_warehouse_available = branch_office_warehouse_available;
}

export function setBranchOfficeWarehouseConditioning(state, branch_office_warehouse_conditioning) {
    state.branch_office_warehouse_conditioning = branch_office_warehouse_conditioning;
}

export function setStates(state, states) {
    state.states = states;
}

export function setPdf(state, pdf) {
    state.pdf = pdf;
}

export function setShowModalPdf(state, show) {
    state.modal_pdf.show = show;
}

export function setGetData(state, get_data) {
    state.get_data = get_data;
}

export function setBranchOfficeWarehouses(state, branch_offices_warehouses) {
    state.branch_offices_warehouses = branch_offices_warehouses;
}

export function setPreloader(state, preloader) {
    state.preloader = preloader;
}










// WEBPACK FOOTER //
// ./src/modules/conditioning/mutations.js